const { Core, Utils } = Global;
const { $state } = Utils;

function isPositiveInteger(value) {
    return Number.isInteger(value) && value > 0;
}

customElements.define('product-qty-input', class extends Core {
    elements = {
        $: ['button-minus', 'button-plus', 'input']
    }

    currentValue = 1;

    render() {
        this.currentValue = this.inputValue;

        this.$('button-plus', { click: this._changeBy(1) });
        this.$('button-minus', { click: this._changeBy(-1) });
        this.$('input', { change: this._handleChange });

        this._applyCurrentValue();
    }

    _changeBy(direction) {
        return () => {
            const nextValue = this.currentValue + (this.qtyStep * direction);

            if (direction > 0 && this.qtyLimit && nextValue > this.qtyLimit) {
                return;
            }

            if (direction < 0 && nextValue < this.qtyMin) {
                return;
            }

            this.currentValue = nextValue;
            this._applyCurrentValue();
        }
    }

    _handleChange({ target }) {
        const value = target.valueAsNumber;

        if (!isPositiveInteger(value)) {
            this.currentValue = this.qtyMin;
        } else if (this.qtyLimit && value > this.qtyLimit) {
            this.currentValue = this._getHighestValidValue();
        } else if (value < this.qtyMin) {
            this.currentValue = this.qtyMin;
        } else {
            this.currentValue = this._getClosestValidValue(value);
        }

        this._applyCurrentValue();
    }

    _getClosestValidValue(value) {
        const offset = value - this.qtyMin;
        const steps = Math.round(offset / this.qtyStep);

        return this.qtyMin + (steps * this.qtyStep);
    }

    _getHighestValidValue() {
        if (!this.qtyLimit) {
            return this.currentValue;
        }

        const offset = this.qtyLimit - this.qtyMin;
        const steps = Math.floor(offset / this.qtyStep);

        return this.qtyMin + (steps * this.qtyStep);
    }

    _applyCurrentValue() {
        this.$('input').value = this.currentValue;
        this._toggleButtons();
    }

    _toggleButtons() {
        this.$('button-minus').toggleAttribute(
            'disabled',
            this.currentValue <= this.qtyMin
        );

        if (this.qtyLimit) {
            this.$('button-plus').toggleAttribute(
                'disabled',
                this.currentValue + this.qtyStep > this.qtyLimit
            );
        } else {
            this.$('button-plus').removeAttribute('disabled');
        }
    }

    get inputValue() {
        const value = this.$('input').valueAsNumber;
        return isPositiveInteger(value) ? value : this.qtyMin;
    }

    get qtyMin() {
        return +this.$('input').getAttribute('min') || 1;
    }

    get qtyStep() {
        return +this.$('input').getAttribute('step') || 1;
    }

    get qtyLimit() {
        const max = this.$('input').getAttribute('max');
        return max ? +max : null;
    }
});